export const SET_CORRECTION_REQUEST_LOADING = 'SET_CORRECTION_REQUEST_LOADING'
export const SET_CORRECTION_REQUEST = 'SET_CORRECTION_REQUEST'
export const SET_OV_GET_LOCATIONS = 'SET_OV_GET_LOCATIONS'
export const ADD_CORRECTION_REQUEST = 'ADD_CORRECTION_REQUEST'
export const EDIT_CORRECTION_REQUEST = 'EDIT_CORRECTION_REQUEST'
export const DELETE_CORRECTION_REQUEST = 'DELETE_CORRECTION_REQUEST'
export const SET_CORRECTION_TEAM_REQUEST = 'SET_CORRECTION_TEAM_REQUEST'